export default "__VITE_ASSET__5Y1KXVQQ__"